{
  "main": {
    "title": "Šifrant pilotov",
    "nazaj": "Nazaj"
  },
  "navs": {
    "vnos": "Vnos",
    "seznam": "Seznam"
  },
  "search":{
    "placeholder": "Išči po šifri, imenu ali priimku"
  },
  "table": {
    "sifra":"Šifra",
    "ime":"Ime",
    "priimek":"Priimek",
    "podrobno":"podrobno"
  },
  "modal": {
    "sifra":"Šifra:",
    "naslov":"Naslov:",
    "posta":"Pošta:",
    "kraj":"Kraj:",
    "email":"E-naslov:",
    "telefon":"Telefon:",
    "klub":"Klub:",
    "naletJ":"Nalet jadralno:",
    "naletM":"Nalet motorno: ",
    "opomba":"Opomba:",
    "instruktor":"Inštruktor:",
    "instruktorJ":"Inštruktor jadralnega letala:",
    "instruktorUL": "Inštruktor ultralight letala:",
    "vlecniR":"Vlečni rating",
    "jadralniP": "Pilot jadralnega letala?",
    "motorniP": "Pilot motornega letala?",
    "ultraP": "Pilot ultralight letala?"
  },
  "vabilo": {
    "title":"Poskenirajte QR kodo",
    "opomba": "Uporabnik že ima dostop do aplikacije!"
  },
  "labels": {
    "ime":"Ime",
    "priimek":"Priimek",
    "naslov":"Naslov",
    "posta":"Pošta",
    "kraj":"Kraj",
    "email":"E-naslov",
    "telefon":"Telefon",
    "klub":"Klub",
    "klubI":"Izberi klub :",
    "naletJ":"Nalet jadralno:",
    "naletM":"Nalet motorno:",
    "opomba":"Opomba:",
    "instruktor":"Inštruktor:",
    "instruktorJ":"Inštruktor jadralnega:",
    "instruktorUL":"Inštruktor ultralight:",
    "vlecniR":"Vlečni rating:",
    "jadralniP": "Pilot jadralnega letala",
    "motorniP": "Pilot motornega letala",
    "ultraP": "Pilot ultralight letala",
    "licenca":"Licenca:"
  },
  "buttons": {
    "csv": "Izvoz v csv",
    "povabi":"Povabi",
    "deli":"Deli",
    "uredi":"Uredi",
    "posodobi":"Posodobi podatke",
    "izbrisi":"Izbriši",
    "brisiIzbiro":"Pobriši izbiro"
  }
}